import { pendingCount, type ItemLike } from './purchaseOrderItemView.js';

/**
 * Barra de "líneas del documento que quedaron sin producto".
 *
 * Es un componente con nombre y no un bloque suelto dentro de la pantalla por una
 * razón concreta: así se puede **renderizar en un test** y verificar qué texto
 * aparece. Los últimos bugs de esta celda fueron de visibilidad —un aviso en una
 * orden vacía, una caja que sobrevivió a dos rediseños— y la única forma de
 * atraparlos sin mirar la pantalla es renderizar.
 */
export function PendingLinesBar({ items, onRemove }: { items: ItemLike[]; onRemove: () => void }) {
  const pendientes = pendingCount(items);
  if (!pendientes) return null;

  return (
    <div className="mb-2 flex flex-wrap items-center justify-between gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 dark:border-amber-700 dark:bg-amber-900/20">
      <p className="text-xs text-amber-800 dark:text-amber-200">
        {pendientes === 1
          ? 'Una línea del documento quedó sin producto.'
          : `${pendientes} líneas del documento quedaron sin producto.`}{' '}
        Elegí una de las opciones sugeridas, buscá el producto, o quitá la línea del pedido.
      </p>
      <button
        type="button"
        onClick={onRemove}
        className="px-3 py-1.5 rounded-lg text-xs font-semibold bg-amber-600 hover:bg-amber-700 text-white min-h-[36px]"
      >
        {pendientes === 1 ? 'Quitar la línea del pedido' : `Quitar las ${pendientes} del pedido`}
      </button>
    </div>
  );
}
